import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import {
    PrivaFilterSearchComponent,
    PrivaFilterSearchConfig,
    PrivaQueryableDataSource,
    PrivaQueryableDataSourceFactory,
} from '@priva/components/filter';
import { PrivaNotificationComponent } from '@priva/components/notification';
import { PrivaTableColumnDirective, PrivaTableComponent, PrivaTableRowEvent } from '@priva/components/table';
import { PrivaLocalizationModule } from '@priva/localization';

import { TerminalOverlayComponent } from 'app/shared/components';
import { selectBatches } from 'app/shared/features/batch-selector/state/batch.selectors';

import { Batch } from './models/batch';

@Component({
    selector: 'app-batch-selector',
    templateUrl: './batch-selector.component.html',
    styleUrl: './batch-selector.component.scss',
    imports: [
        PrivaFilterSearchComponent,
        PrivaLocalizationModule,
        PrivaNotificationComponent,
        PrivaTableComponent,
        PrivaTableColumnDirective,
        TerminalOverlayComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchSelectorComponent {
    store = inject(Store);
    private dataSourceFactory = inject(PrivaQueryableDataSourceFactory);

    title = input('');

    closeRequested = output();
    batchSelected = output<Batch>();

    batchList: Batch[] = [];

    onCloseRequested(): void {
        this.closeRequested.emit();
    }

    // Filter
    filterSearchConfig: PrivaFilterSearchConfig = {
        type: 'search',
        id: 'searchBatch',
        title: 'GENERAL.TITLE.SEARCH_BATCH',
        placeholder: 'GENERAL.TITLE.SEARCH_BATCH',
        options: ['name'],
        searchOptions: {
            matchType: 'single',
        },
    };

    readonly batchDataSource: PrivaQueryableDataSource<Batch>;

    constructor() {
        // Update batch list based on search filter
        this.batchDataSource = this.dataSourceFactory.create();
        this.batchDataSource.setData(this.store.select(selectBatches));
        this.batchDataSource.results$.pipe(takeUntilDestroyed()).subscribe((filteredBatches) => {
            this.batchList = filteredBatches;
        });
    }

    onTableRowClick(event: PrivaTableRowEvent<Batch>) {
        const batch = event.row;
        this.batchSelected.emit(batch);
    }
}
